import React from "react";
import PropTypes from "prop-types";
import { renderStars } from "../../helpers/reviewHelper";
import { formatDateTimeForUserTimeZone } from "../../helpers/DateTimeFormatter";
import RatingsDisplay from "./ratingsDisplay";
import User from '../../assets/icons/user.png'

const ReviewCard = ({ review, manufacturerName }) => {
    if (!review) return null;


    return (
        <div className="user-review-card">
            {/* Reviewer */}
            <div className="product-user-info">
                <img
                    src={"" || User}
                    alt="Reviewer avatar"
                    className="review-user-img"
                />
                <h5>{review?.reviewerName || "Anonymous"}</h5>
            </div>


            {/* Headline */}
            {review?.title && (
                <h5 className="reviewTitle" style={{ marginBottom: 8 }}>
                    {review.title} <span style={{marginLeft : "auto", display:"inline-block"}}>{renderStars(review?.averageRating ?? 0)}</span>
                </h5>
            )}

            {/* Metadata */}
            <h5 className="metaData" style={{ fontWeight: '400' }}>
                Reviewed in the {review?.districtName || ""} -{" "}
                {review?.schoolName || ""} on{" "}
                {formatDateTimeForUserTimeZone(review?.created) || new Date().toLocaleDateString()}
            </h5>
            <div className="product-detail-list" style={{ marginBottom: 0 }}>
                <p>
                    Manufacturer {manufacturerName || ""} |{" "}
                    <span style={review?.isSchoolVerified == 1 ? { color: "#2ecc71" } : {}}>School Verified</span>
                </p>
            </div>

            {/* Ratings */}
            <RatingsDisplay review={review} />

            {/* Review Text */}
            {review?.description && (
                <div className="product-detail-list product-detail-description">
                    <p>{review.description}</p>
                </div>
            )}
        </div>
    );
};

ReviewCard.propTypes = {
    review: PropTypes.shape({
        reviewerName: PropTypes.string,
        title: PropTypes.string,
        districtName: PropTypes.string,
        schoolName: PropTypes.string,
        created: PropTypes.string,
        description: PropTypes.string,
        averageRating: PropTypes.number,
        isSchoolVerified: PropTypes.number,
    }),
    manufacturerName: PropTypes.string,
};

export default ReviewCard;
